export default "__VITE_PUBLIC_ASSET__b99d6e21__"